module.exports = __webpack_public_path__ + "img/wap_logo.1767c8b6.png";